import moment from 'moment/moment';

export const default_training = () => {
    return {
        id: null,
        date: moment().format('YYYY-MM-DD'),
        code: null,
        name: null,
        intensity: null,
        topics: null,
        workers: []
    };
};

export const default_params = () => {
    return {
        company_id: null,
        filter: null,
        paginate: 1,
        page: 1,
        per_page: 10
    };
};

export default {
    companies: [],
    training_companies: [],
    workers: [],
    trainings: {
        data: []
    },
    modal: {show: false},
    modal_upload: {show: false},
    training: default_training(),
    params: default_params(),
    editing: false,
    upload: {
        file: null
    }
};
